import { useQuery } from '@tanstack/react-query';
import { getReferrersStatistics } from '../api/getReferrersStatistics';

export const QUERY_KEY = 'referrerStatistics';

const useGetReferrersStatistics = (filters: {
  startDate: Date;
  endDate: Date;
  pageSize: number;
  pageNumber: number;
  sortOrder: string;
  selectedIdentityId?: string;
  branchId?: number;
  modalityId?: number;
}) => {
  const { data: referrersStatistics, ...rest } = useQuery({
    queryKey: [
      QUERY_KEY,
      filters.startDate,
      filters.endDate,
      filters.pageSize,
      filters.pageNumber,
      filters.sortOrder,
      filters.selectedIdentityId,
      filters.branchId,
      filters.modalityId,
    ],
    queryFn: () => getReferrersStatistics(filters),
    staleTime: 1000 * 60 * 5,
  });

  return {
    referrersStatistics,
    ...rest,
  };
};

export default useGetReferrersStatistics;
